<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          class="box"
          ref="inquiryForm"
          :model="inquiry"
          label-width="70px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('inquiry.serialNo')">{{
                  inquiry.serialNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('inquiry.type')">{{
                  $t("inquiryTypes." + inquiry.type)
                }}</el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('inquiry.inquiryAt')">{{
                  inquiry.inquiryAt
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('inquiry.expirateAt')">{{
                  inquiry.expirateAt
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">{{
                  inquiry.productNo
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.quantity')">{{
                  inquiry.quantity
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <el-row :gutter="10">
            <el-col :span="12">
              <fieldset v-if="inquiry.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail
                  :images="inquiry.images"
                  :list="true"
                  width="50"
                  height="auto"
                />
              </fieldset>
            </el-col>
            <el-col v-if="inquiry.explain != null" :span="12">
              <fieldset class="mgb15">
                <legend>{{ $t("text.explain") }}</legend>
                {{ inquiry.explain }}
              </fieldset>
            </el-col>
          </el-row>
          <fieldset v-for="(item, index) in items" :key="item.id" class="mgb15">
            <legend>
              第 {{ index + 1 }} 次 报价于
              <small>&nbsp;{{ item.quoteAt }}</small>
            </legend>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="$t('quotation.price')">{{
                  item.quotation | currency
                }}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('text.explain')">{{
                  item.explain
                }}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('menu.suppliers')">{{
                  item.supplierTenantName
                }}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="'账户'">{{ item.phone }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import Util from "@/utils/index.js";
import Inquiry from "@/api/inquiry.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Thumbnail,
  },
  data() {
    return {
      inquiry: { serialNo: null, type: "private" },
      items: [],
      Util: Util,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    Inquiry.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.inquiry = res.data.entity;
        if (res.data.entity.inquiryItems != null) {
          self.items = res.data.entity.inquiryItems.filter(
            (i) => i.quotation != null
          );
        }
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {},
};
</script>